import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import { Fade, makeStyles, RaiseColors, useMediaQuery, useTheme } from "client/componentLibrary";
import React from "react";
import { Link } from "react-router-dom";
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
var useStyles = function useStyles() {
  var theme = useTheme();
  return makeStyles(function () {
    return {
      signInPageContainer: _defineProperty(_defineProperty(_defineProperty({
        margin: "auto",
        maxWidth: "368px",
        paddingLeft: "12px",
        paddingRight: "12px"
      }, theme.breakpoints.up("md"), {
        paddingTop: "22vh"
      }), theme.breakpoints.down("smMd"), {
        paddingTop: "11vh"
      }), "overflow", "hidden"),
      termsAndConditions: {
        color: RaiseColors.gray200,
        fontSize: "12px",
        textDecoration: "none",
        paddingTop: "8px",
        "&:hover": {
          fontWeight: 600,
          color: RaiseColors.shamrock
        }
      },
      privacyPolicy: {
        position: "fixed",
        bottom: "8px",
        margin: "auto",
        maxWidth: "336px",
        width: "calc(100% - 16px)"
      },
      termsContainer: {
        width: "fit-content",
        margin: "auto"
      },
      logoPadding: _defineProperty({
        height: "64px"
      }, theme.breakpoints.down("md"), {
        height: "48px"
      }),
      icon: {
        height: "100%",
        "float": "left",
        minHeight: "580px"
      },
      container: {
        height: "100%"
      },
      largeImage: {
        display: "block",
        margin: "auto",
        width: "275px"
      },
      smallImage: {
        display: "block",
        margin: "auto",
        width: "45px"
      }
    };
  });
};
function LogoFormatContainer(_ref) {
  var children = _ref.children,
    disableLogoUnderpadding = _ref.disableLogoUnderpadding,
    disableLink = _ref.disableLink,
    _ref$fade = _ref.fade,
    fade = _ref$fade === void 0 ? false : _ref$fade,
    onFinishedLogoFade = _ref.onFinishedLogoFade;
  var theme = useTheme();
  var classes = useStyles()();
  var inSmallView = useMediaQuery(theme.breakpoints.down("md"));
  return /*#__PURE__*/_jsx("div", {
    className: classes.container,
    children: /*#__PURE__*/_jsxs(_Fragment, {
      children: [!inSmallView && /*#__PURE__*/_jsx("div", {
        className: classes.icon,
        children: disableLink ? /*#__PURE__*/_jsx("img", {
          alt: "Raise Icon",
          src: "".concat(window.STATIC_URL, "images/logos/Raise/Raise_Mark_GreenBeans_Background.svg"),
          height: "100%"
        }) : /*#__PURE__*/_jsx(Link, {
          to: "/raise_login",
          children: /*#__PURE__*/_jsx("img", {
            alt: "Raise Icon",
            src: "".concat(window.STATIC_URL, "images/logos/Raise/Raise_Mark_GreenBeans_Background.svg"),
            height: "100%"
          })
        })
      }), /*#__PURE__*/_jsx("div", {
        className: classes.signInPageContainer,
        children: /*#__PURE__*/_jsxs("div", {
          children: [!inSmallView ? /*#__PURE__*/_jsx(_Fragment, {
            children: disableLink ? /*#__PURE__*/_jsx(Fade, {
              "in": true,
              timeout: fade ? {
                enter: 500
              } : {
                enter: 0
              },
              onEntered: onFinishedLogoFade,
              children: /*#__PURE__*/_jsx("img", {
                className: classes.largeImage,
                alt: "Raise Logo Text",
                src: "".concat(window.STATIC_URL, "images/logos/Raise/Logo_White.png")
              })
            }) : /*#__PURE__*/_jsx(Link, {
              to: "/raise_login",
              children: /*#__PURE__*/_jsx("img", {
                className: classes.largeImage,
                alt: "Raise Logo Text",
                src: "".concat(window.STATIC_URL, "images/logos/Raise/Logo_White.png")
              })
            })
          }) : /*#__PURE__*/_jsx(Fade, {
            "in": true,
            timeout: fade ? {
              enter: 500
            } : {
              enter: 0
            },
            onEntered: onFinishedLogoFade,
            children: disableLink ? /*#__PURE__*/_jsx("img", {
              alt: "Raise Logo Text",
              className: classes.smallImage,
              src: "".concat(window.STATIC_URL, "images/logos/Raise/Vertical_Full_White.png")
            }) : /*#__PURE__*/_jsx(Link, {
              to: "/raise_login",
              children: /*#__PURE__*/_jsx("img", {
                alt: "Raise Logo Text",
                className: classes.smallImage,
                src: "".concat(window.STATIC_URL, "images/logos/Raise/Vertical_Full_White.png")
              })
            })
          }), !disableLogoUnderpadding && /*#__PURE__*/_jsx("div", {
            className: classes.logoPadding
          }), children, /*#__PURE__*/_jsxs("div", {
            className: classes.privacyPolicy,
            children: [/*#__PURE__*/_jsx("div", {
              className: classes.termsContainer,
              children: /*#__PURE__*/_jsx("a", {
                href: "https://www.jllt.com/legal-agreements/jllt/terms-of-service/",
                target: "_blank",
                rel: "noopener noreferrer",
                className: classes.termsAndConditions,
                children: "Terms of Service"
              })
            }), /*#__PURE__*/_jsx("div", {
              className: classes.termsContainer,
              children: /*#__PURE__*/_jsx("a", {
                href: "https://www.us.jll.com/en/privacy-statement",
                target: "_blank",
                rel: "noopener noreferrer",
                className: classes.termsAndConditions,
                children: "Privacy Policy"
              })
            })]
          })]
        })
      })]
    })
  });
}
export default LogoFormatContainer;